import Sortable from 'sortablejs';
const TagOrderer = {
  init() {
    if (!($('.career-tag-prefs').length > 0)) return;
    Sortable.create($('.reorderable-tags')[0]);
  }
};

$(document).ready(()=> {
  TagOrderer.init();
});
